var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('div',{staticClass:"flex px-2 py-1"},[_c('Notification'),_c('Complaint')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }